import { Chip } from '@mui/material';
import { generateUniqueKey } from '../../../helpers/app';
import StyledExternalCapabilities from './StyledExternalCapabilities';

interface ExternalCapabilitiesProps {
  capabilities: string[];
}
const ExternalCapabilities: React.FC<ExternalCapabilitiesProps> = ({
  capabilities,
}) => {
  return (
    <StyledExternalCapabilities>
      {capabilities.map(capability => (
        <li key={generateUniqueKey()}>
          <Chip
            label={capability}
            variant="filled"
            color="default"
            size="medium"
          ></Chip>{' '}
        </li>
      ))}
    </StyledExternalCapabilities>
  );
};

export default ExternalCapabilities;
